<template>
    <div class="historial-item-moderno" @click="$emit('seleccionar', item)">
        <!-- Contenido del item sin iconos -->
        <div class="item-contenido">
            <div class="item-header">
                <span class="item-titulo">{{ formatearTitulo(item) }}</span>
                <span class="item-badge-fecha">
                    {{ formatearFechaHora(item.timestamp) }}
                </span>
            </div>
            <div v-if="formatearTiempo(item.timestamp)" class="item-meta">
                <span class="item-tiempo-relativo">{{ formatearTiempo(item.timestamp) }}</span>
            </div>
        </div>
    </div>
</template>

<script setup>
defineProps({
    item: {
        type: Object,
        required: true
    }
});

defineEmits(['seleccionar']);

// Mapeo de etiquetas
const etiquetas = {
    'perfil-paciente': 'Perfil del Paciente',
    'notas-medicas': 'Notas Médicas',
    'nota-medica': 'Nota Médica',
    'nueva-nota': 'Nueva Nota',
    'receta': 'Receta',
    'nueva-receta': 'Nueva Receta',
    'documento': 'Documento',
    'documentos': 'Documentos',
    'evolucion': 'Evolución',
    'historia-clinica': 'Historia Clínica',
    'default': 'Acción'
};

// Métodos
const formatearTitulo = (item) => {
    if (item.titulo) return item.titulo;

    const etiqueta = etiquetas[item.modo] || etiquetas.default;
    if (item.detalle) {
        return `${etiqueta} - ${item.detalle}`;
    }
    return etiqueta;
};

const formatearTiempo = (timestamp) => {
    if (!timestamp) return '';

    const ahora = new Date();
    const fecha = new Date(timestamp);
    const diff = Math.floor((ahora - fecha) / 1000);

    if (diff < 60) return '';  // No mostrar nada si es reciente
    if (diff < 3600) return `Hace ${Math.floor(diff / 60)} min`;
    if (diff < 86400) return `Hace ${Math.floor(diff / 3600)} h`;
    return fecha.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' });
};

const formatearFechaHora = (timestamp) => {
    if (!timestamp) {
        const ahora = new Date();
        return ahora.toLocaleString('es-ES', {
            day: '2-digit',
            month: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
    }

    const fecha = new Date(timestamp);
    const ahora = new Date();
    const esHoy = fecha.toDateString() === ahora.toDateString();

    if (esHoy) {
        return 'Hoy, ' + fecha.toLocaleTimeString('es-ES', {
            hour: '2-digit',
            minute: '2-digit'
        });
    }

    return fecha.toLocaleString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    });
};
</script>

<style scoped>
/* ========================================
   ITEM MODERNO DEL HISTORIAL - SIN ICONOS
======================================== */
.historial-item-moderno {
    padding: 0.5rem 0.75rem;
    cursor: pointer;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    border-radius: 8px;
    position: relative;
    background: white;
    border-left: 3px solid transparent;
}

.historial-item-moderno:hover {
    background: linear-gradient(135deg, rgba(59, 130, 246, 0.04) 0%, rgba(147, 197, 253, 0.04) 100%);
    border-left-color: #3b82f6;
    transform: translateX(3px);
    box-shadow: 0 2px 12px rgba(59, 130, 246, 0.08);
}

/* Contenido del item */
.item-contenido {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
}

.item-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 0.5rem;
}

.item-titulo {
    font-size: 0.875rem;
    font-weight: 600;
    color: #1e293b;
    line-height: 1.4;
    flex: 1;
    letter-spacing: -0.01em;
}

.item-badge-fecha {
    display: inline-flex;
    align-items: center;
    padding: 0.15rem 0.5rem;
    border-radius: 6px;
    font-size: 0.6875rem;
    font-weight: 600;
    letter-spacing: 0.3px;
    font-family: 'SF Mono', 'Monaco', 'Courier New', monospace;
    white-space: nowrap;
    flex-shrink: 0;
    background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
    color: #1e40af;
    border: 1px solid rgba(59, 130, 246, 0.1);
}

.item-meta {
    display: flex;
    align-items: center;
    padding-left: 0;
}

.item-tiempo-relativo {
    font-size: 0.75rem;
    color: #64748b;
    font-weight: 500;
}

/* ========================================
   ANIMACIONES
======================================== */
@keyframes fadeInSlide {
    from {
        opacity: 0;
        transform: translateX(-10px);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.historial-item-moderno {
    animation: fadeInSlide 0.3s ease backwards;
}
</style>
